export default __webpack_public_path__ + "static/sixth-f4af0fda3b376d55c6fe64ffb403306b.png";